'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Arrow } from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const DropdownArrow = forwardRef(({ className, ...props }, ref) => (_jsx(Arrow, { ref: ref, height: 12, width: 20, accumulate: "sum", className: cn('z-50 fill-white dark:fill-metal-900', className), ...props })));
DropdownArrow.displayName = 'DropdownArrow';
export { DropdownArrow };
